module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjU2MCIgd2lkdGg9Ijc0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjQzYwQzMwIiBkPSJNMCAwaDc0MHY1NjBIMHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMjQwIDBoODB2NTYwaC04MHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMCAyNDBoNzQwdjgwSDB6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/dnk.svg
// module id = vkAE
// module chunks = 0